import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { api } from '@services/api';

interface Props {
  token?: string;
}

export function VerifyEmailPage({ token }: Props) {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setError('유효하지 않은 인증 링크입니다.');
        setLoading(false);
        return;
      }

      const response = await api.get<any>(`/api/auth/verify-email?token=${token}`);

      if (response.success) {
        setSuccess(true);
      } else {
        setError(response.error || '이메일 인증에 실패했습니다.');
      }

      setLoading(false);
    };

    verifyEmail();
  }, [token]);

  return (
    <div class="flex min-h-screen items-center justify-center bg-gray-100">
      <div class="card w-full max-w-md">
        <div class="mb-6 flex flex-col items-center">
          <img src="/logo.svg" alt="DbitLabs Logo" class="mb-3 h-16 w-16" />
          <h1 class="font-brand text-center text-2xl font-bold">DbitLabs : IssueManager</h1>
        </div>

        <h2 class="mb-6 text-center text-lg font-semibold text-gray-700">이메일 인증</h2>

        {loading ? (
          <div class="text-center">
            <div class="text-lg">이메일 인증 중...</div>
          </div>
        ) : success ? (
          <div class="text-center">
            <div class="mb-4 rounded bg-green-100 p-4 text-green-700">
              <p class="font-medium">이메일 인증이 완료되었습니다!</p>
              <p class="mt-2 text-sm">이제 로그인하실 수 있습니다.</p>
            </div>
            <button
              onClick={() => route('/login')}
              class="btn btn-primary text-white"
            >
              로그인 페이지로 이동
            </button>
          </div>
        ) : (
          <div class="text-center">
            <div class="mb-4 rounded bg-red-100 p-4 text-red-700">
              <p class="font-medium">인증 실패</p>
              <p class="mt-2 text-sm">{error}</p>
            </div>
            <a
              href="/login"
              class="text-sm text-primary-600 hover:text-primary-700 hover:underline"
            >
              로그인 페이지로 이동
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
